import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import Box from "@mui/material/Box";
import LeftArrowIcon from "../../images/right_arrow.svg";
import {
  getVeevaLinkedModulesListByid,
  getSelectedModulecardDetails,
  getModuleCardDetails,
  updateModuleCardsinEditor,
} from "../../services/apis";
import "./LeftContentPanel.scss";
import GreenTickMark from "../../images/MLR StatusGreen.png";
import Rectangle from "../../images/Rectangle.svg";
import ModuleCardsWindow from "./ModuleCardsWindow";
import AssociatedModules from "./AssociatedModules";
import consolidateData from "../RunValidationCheck/ConsolidateData";

const LeftContentPanel = (props) => {
  const [activeKey, setActiveKey] = useState("approved");
  const {
    sendAtomDetails2Canvas,
    handleModuleWindow,
    appData,
    searhModuleModal,
    customDrag,
    editor,
    selectedModule,
    setSelectedModule,
    activeTab,
  } = props;
  const [associatedCards, setAssociatedCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [moduleCardsDataLHS, setModuleCardsDataLHS] = useState([]);
  const [moduleClaimsData, setModuleClaimsData] = useState([]);
  const [openModulesModal, setOpenModulesModal] = useState(false);
  const [openModulesScreen, setOpenModulesScreen] = useState(false);
  const [noBussinessRules, setNoBussinessRules] = useState(false);
  const [module_id_List, setModule_id_List] = useState([]);
  const [allModuleData, setAllModuleData] = useState([]);

  useEffect(() => {
    getModules();
  }, [searhModuleModal]);

  const getModules = () => {
    setIsLoading(true);
    // console.log('eee----', appData);
    // appData.setDeckId({ ...appData?.deckId, _id: edetailId });
    getVeevaLinkedModulesListByid(
      appData?.deckId?._id,
      (response, err, errorCode) => {
        if (err) {
          setIsLoading(false);
        } else {
          setModuleCardsDataLHS(response.data.response.content_modules);
          /* Include parent module names AND every business-rule targetModuleDamName (business rules on this endpoint expose targetModuleDamName directly on the rule, not nested under targetModules[]) so associated/child claims on the canvas (which carry module-claim=targetModuleDamName) survive the [module-claim] cleanup in onLoadCalled on slide re-entry. */
          const moduleList = [
            ...new Set(
              (response?.data?.response?.content_modules ?? []).flatMap((m) => [
                m.module_name,
                ...((m.content_module_response?.moduleBusinessRules ?? []).map(
                  (rule) => rule?.targetModuleDamName,
                )),
              ]).filter(Boolean),
            ),
          ];

          /* const moduleList_id = [
            ...new Set(
              response?.data?.response?.content_modules?.map(
                (m) => m.content_module_response.id,
              ) ?? [],
            ),
          ]; */
          const moduleList_id = [
            ...new Set(
              (response?.data?.response?.content_modules ?? []).flatMap((m) => [
                m.content_module_response?.id,
                ...(m.content_module_response?.moduleBusinessRules?.map(
                  (rule) => rule.targetModuleId
                ) ?? [])
              ])
            )
          ];
          // console.log("modules got on land of editor");
          if (editor) onLoadCalled(editor, moduleList, moduleList_id, "api");
          // if (!editor) return false;
          /* const allComps = editor?.getWrapper();
          if (!allComps || typeof allComps.find !== "function") {
            return false;
          }
          try {
            if (allComps) {
              const claimOnEditor = allComps?.find(`[module-claim]`);
              for (var i = 0; i < claimOnEditor.length; i++) {
                const moduleValue =
                  claimOnEditor[i].getAttributes()["module-claim"];
                if (!moduleList.includes(moduleValue)) {
                  claimOnEditor[i].remove();
                }
              }
            }
          } catch (err) {
            console.error("Error in wrapper.find:", err);
            return false;
          } */
          setIsLoading(false);
        }
      },
    );
  };

  const handleTabSelect = (key) => {
    setActiveKey(key); // Update the active tab when clicked
  };

  const handleGetChildModules = (moduleId) => {
    setIsLoading(true);
    getSelectedModulecardDetails(moduleId, (response, err, errorCode) => {
      if (err) {
        //   const errCoponent = errComponentToRender(errorCode);
        //   categoriesErr(errCoponent);
        //   setLoadingModules(false);
        //   setNoBussinessRules(false);
      } else {
        const businessRules = response?.data?.businessRules;
        let noData = response?.data?.businessRules.length > 0 ? false : true;
        setNoBussinessRules(noData);
        if (!businessRules) {
          setIsLoading(false);
          return;
        }
        const optionalModules = [];
        const mustExistWithModules = [];

        businessRules.forEach((rule) => {
          switch (rule.ruleCondition) {
            case "Optional":
              if (Array.isArray(rule.targetModules)) {
                rule.targetModules.forEach((module) => {
                  if (module.targetModuleMlrStatus === "Available for Use")
                    optionalModules.push({
                      ...module,
                      ruleCondition: rule.ruleCondition,
                    });
                });
              }
              break;
            case "MustExistWith":
              rule.targetModules.forEach((module) => {
                if (module.targetModuleMlrStatus === "Available for Use")
                  mustExistWithModules.push({
                    ...module,
                    ruleCondition: rule.ruleCondition,
                  });
              });
              break;

            default:
              break;
          }
        });
        setAssociatedCards((prevState) => ({
          ...prevState,
          [moduleId]: { optionalModules, mustExistWithModules },
        }));
        setIsLoading(false);
      }
    });
  };

  const handleExpandModuleClaims = (card, type) => {
    let moduleTypeID =
      type === "parentModule"
        ? card?.content_module_response.id
        : card?.targetModuleId;
    getModuleCardDetails(
      moduleTypeID,
      (response, err, errorCode) => {
        if (err) {
        } else {
          // setCardDetails({
          //   cardDetails: true,
          //   data: response.data,
          // });
          setModuleClaimsData(response.data);
        }
      },
      "linkedModulesType",
    );
  };

  editor?.on("load", () => {
    // console.log(
    //   "inside load editor api",
    //   editor,
    //   "all module data",
    //   allModuleData,
    // );
    /* Include associated/child module DAM names (rule.targetModuleDamName is exposed directly on each business rule here) alongside parent module names, so [module-claim] cleanup in onLoadCalled does not remove business-rule (associated) claims when returning to the slide. */
    const moduleList = [
      ...new Set(
        (moduleCardsDataLHS ?? []).flatMap((m) => [
          m.module_name,
          ...((m.content_module_response?.moduleBusinessRules ?? []).map(
            (rule) => rule?.targetModuleDamName,
          )),
        ]).filter(Boolean),
      ),
    ];
    const moduleList_id = [
      ...new Set(
        (moduleCardsDataLHS ?? []).flatMap((m) => [
          m.content_module_response?.id,
          ...(m.content_module_response?.moduleBusinessRules?.map(
            (rule) => rule.targetModuleId
          ) ?? []),
        ]),
      ),
    ];
    onLoadCalled(editor, moduleList, moduleList_id, "editor on load");
  });
  const onLoadCalled = async (editor, moduleList, idList, from) => {
    // console.log("onload called", from);
    const alldata = [];

    if (from === "api") {
      try {
        const apiCalls = idList.map(
          (moduleID) =>
            new Promise((resolve, reject) => {
              getModuleCardDetails(
                moduleID,
                (response, err) => {
                  if (err) reject(err);
                  else {
                    const data = response.data;
                    resolve([
                      ...consolidateData(
                        data.claims,
                        data.moduleDamName,
                        "claims",
                      ),
                      ...consolidateData(
                        data.reusableTexts,
                        data.moduleDamName,
                        "reusableTexts",
                      ),
                       ...consolidateData(
                        data.components,
                        data.moduleDamName,
                        "components",
                      ),
                    ]);
                  }
                },
                "linkedModulesType",
              );
            }),
        );

        const results = await Promise.all(apiCalls);
        const finalResult = results.flat();
        const existContentList = appData.deckId.selected_module_data.filter((module)=> moduleList.includes(module.moduleId));
        // console.log("inputs", finalResult, existContentList);
        const consolidateExisting = (...arrays) => {
          const map = new Map();

          arrays.flat().forEach((item) => {
            if (!item || !item.id) return;

            const existing = map.get(item.id);

            if (!existing) {
              map.set(item.id, { ...item });
            } else {
              map.set(item.id, {
                ...existing,
                ...item,
                used: existing.used || item.used,
              });
            }
          });

          return Array.from(map.values());
        };
        const payload = {
          selected_module_data: consolidateExisting(
            finalResult,
            existContentList,
          ),
        };
        appData.setDeckId({
          ...appData.deckId,
          selected_module_data: consolidateExisting(
            finalResult,
            existContentList,
          ),
          from:'module_page'
        });
        await updateModuleCardsinEditor(
          appData?.deckId?._id,
          payload,
          (response, err, errorCode) => {
            if (err) {
            } else {
            }
          },
        );
      } catch (error) {
        // console.log(error);
      }
    } else if (from === "editor on load") {
      /* getVeevaLinkedModulesListByid(
        appData?.deckId?._id,
        (response, err, errorCode) => {
          if (err) {
            console.log(err);
          } else {
            appData.setDeckId({
              ...appData.deckId,
              selected_module_data:
                response?.data?.response.selected_module_data,
            });
            // setModuleCardsDataLHS(response.data.response.content_modules)
          }
        },
      ); */
    }

    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps) {
        const claimOnEditor = allComps?.find(`[module-claim]`);
        for (var i = 0; i < claimOnEditor.length; i++) {
          const moduleValue = claimOnEditor[i].getAttributes()["module-claim"];
          if (!moduleList.includes(moduleValue)) {
            claimOnEditor[i].remove();
          }
        }
      }
    } catch (err) {
      // console.error("Error in wrapper.find:", err);
      return false;
    }
  };

  return (
    <div className="left-content-panel">
      <Tabs
        defaultActiveKey={activeKey}
        onSelect={handleTabSelect}
        id="controlled-tab-example"
        className="left-panel-approved-tab"
      >
        <Tab eventKey="approved" id="left-panel-approved-tab">
          <div className="">
            {selectedModule === undefined && (
              <>
                <div class="approve-content">Approved Content</div>
                <ModuleCardsWindow
                  setSelectedModule={setSelectedModule}
                  setOpenModulesScreen={setOpenModulesScreen}
                  setOpenModulesModal={setOpenModulesModal}
                  handleModuleWindow={handleModuleWindow}
                  handleExpandModuleClaims={handleExpandModuleClaims}
                  handleGetChildModules={handleGetChildModules}
                  sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                  associatedCards={associatedCards}
                  moduleCardsDataLHS={moduleCardsDataLHS}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                  activeTab={activeTab}
                  editor={editor}
                />
              </>
            )}
            <div className="left-content-module-card">
              {selectedModule !== undefined && (
                <AssociatedModules
                  selectedModule={selectedModule}
                  setSelectedModule={setSelectedModule}
                  moduleClaimsData={moduleClaimsData}
                  sendAtomDetails2Canvas={sendAtomDetails2Canvas}
                  customDrag={customDrag}
                  editor={editor}
                />
              )}
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};

export default LeftContentPanel;
